class Remitter {
  constructor() {
    this.listeners = /* @__PURE__ */ new Map();
    this.relayListeners = /* @__PURE__ */ new Set();
  }
  emit(eventName, eventData) {
    var _a;
    (_a = this.listeners.get(eventName)) == null ? void 0 : _a.forEach((listener) => listener(eventData));
  }
  on(eventName, listener) {
    let listeners = this.listeners.get(eventName);
    if (!listeners) {
      listeners = /* @__PURE__ */ new Set();
      this.listeners.set(eventName, listeners);
    }
    listeners.add(listener);
    if (listeners.size === 1) {
      this.relayListeners.forEach((listener2) => listener2.start(eventName));
    }
    return () => {
      this.off(eventName, listener);
    };
  }
  off(eventName, listener) {
    const listeners = this.listeners.get(eventName);
    if (listeners) {
      const result = listeners.delete(listener);
      if (listeners.size <= 0) {
        this.listeners.delete(eventName);
        this.relayListeners.forEach((listener2) => listener2.dispose(eventName));
      }
      return result;
    }
    return false;
  }
  clear(eventName) {
    var _a;
    if (eventName) {
      (_a = this.listeners.get(eventName)) == null ? void 0 : _a.clear();
    } else {
      this.listeners.clear();
    }
  }
  count(eventName) {
    var _a;
    if (eventName) {
      return ((_a = this.listeners.get(eventName)) == null ? void 0 : _a.size) || 0;
    } else {
      let count = 0;
      this.listeners.forEach((listeners) => {
        count += listeners.size;
      });
      return count;
    }
  }
  remit(eventName, start) {
    let disposer;
    const relayListener = {
      start: (name) => {
        if (name === eventName) {
          disposer = start(this);
        }
      },
      dispose: (name) => {
        if (disposer && (!name || name === eventName)) {
          disposer();
        }
      }
    };
    this.relayListeners.add(relayListener);
    return () => {
      this.relayListeners.delete(relayListener);
      if (disposer) {
        disposer();
      }
    };
  }
  destroy() {
    this.clear();
    this.relayListeners.forEach((listener) => listener.dispose());
    this.relayListeners.clear();
  }
}
export { Remitter };
//# sourceMappingURL=remitter.es.js.map
